export let cfValue =  [
    {id: "cfValue", comparator: (item1, item2) => {
        const firstField = item1.cfValue;
        const secondField = item2.cfValue;
        return firstField > secondField ? 1 : firstField < secondField ? -1 : 0;
    }}
]
